import { useStaticQuery, graphql } from 'gatsby'

export const useVideoSectionQuery = () => {
  const { wpPage } = useStaticQuery(graphql`
    query VideoSectionQuery {
      wpPage(title: { eq: "Home" }) {
        videoSection {
          videoSection {
            title
            mobileImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: [WEBP], sizes: "86vw")
                }
              }
            }
            desktopImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: [WEBP], sizes: "63vw")
                }
              }
            }
            playButton {
              localFile {
                publicURL
              }
            }
            videoUrl {
              url
            }
            title2
            text
            link {
              url
            }
          }
        }
      }
    }
  `)
  return wpPage.videoSection.videoSection
}
